define(["core/urls",
        "core/uploader",
        "core/logo-repository",
        "components/modal",
], function (
    urls,
    uploader, 
    logo_repository, 
    modal
) {

    let nodes = {
        uploadLogoButton: document.querySelector(".upload-logo"),
        progress: document.querySelector(".marketing-loader"),
        modalUploadLogoContent: document.querySelector('.modal-template-upload_js'),
        logoWrapper: document.querySelector(".logo-wrapper"),
        messages: {
            success: document.querySelector(".messages .success"),
            error: document.querySelector(".messages .error"),
        },
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".logo-manager"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
    }

    let LogoRepository = logo_repository.LogoRepository;
    var createdModal = modal.create(nodes.modal, function (el) {});

    let imageWorker = {
        set: function (img) {
            this.image = img
        },
        save: function () {
            storage.addObj("conf-email-img", this.image || {id: "", title: "", src: ""});
        },
        get: function () {
            return this.image
        },
        remove: function () {
            storage.removeItem("conf-email-img");
        }
    };

    let addLogoToPage = (imageData) => {
        document.querySelector(".no-logos").classList.add("hide");

        let newLogo = `
            <div class="logo" data-id="${imageData.id}" data-title="${imageData.title}"
                data-uploaded="">
                <div class="date-banner">Uploaded now</div>
                <img src="${imageData.src}" alt="${imageData.title}">
                <div class="tooltip-wrap delete">
                    <div class="delete-logo glyphicons glyphicons-remove-sign" data-id="${imageData.id}"></div>
                    <div class="sb-tooltip">
                        Delete logo
                    </div>
                </div>
                <div class="confirm-delete sb-tooltip">
                        Really delete?
                        <div class="options">
                            <span class="confirm" data-id="${imageData.id}">Yes</span>
                            <span class="deny" data-id="${imageData.id}">No</span>
                        </div>
                    </div>
            </div>
        `
        nodes.logoWrapper.innerHTML = newLogo + nodes.logoWrapper.innerHTML;
        progress.stop();
    }

    let showConfirmDelete = (id) => {
        let wrapper = document.querySelector(`.logo[data-id="${id}"]`);
        wrapper.classList.add("confirm");
    }

    let deleteLogo = (id) => {
        progress.start();
        logo_repository.LogoRepository.delete(id);
        document.querySelector(`.logo[data-id="${id}"]`).classList.add("deleted");
        if(!document.querySelectorAll(".logo").length) {
            document.querySelector(".no-logos").classList.remove("hide");
        }
        progress.stop();
    }

    let progress = (() => {
        let p = nodes.progress;
        p.classList.add("disabled");
        return {
            start: function () {
                p.classList.remove("disabled");
            },
            stop: function () {
                p.classList.add("disabled");
            }
        }
    })();

    let showMessage = (type, copy) => {
        if(copy) {
            nodes.messages[type].innerText = copy;
        }

        nodes.messages[type].classList.remove("hidden");

        setTimeout(() => {
            nodes.messages[type].classList.add("hidden");
        }, 5000)
    }

    let uploadError = (data) => {
        showMessage("error", "File type not supported. Please upload a PNG, JPEG or GIF.")
        progress.stop();
    }

    let onUpload = (fileInfo) => {
        logo_repository
            .LogoRepository
            .save(fileInfo.uuid)
            .done(function (logo) 
        {
            let img = {
                title: logo.title,
                id: logo.id,
                src: logo.resource_thumbnail,
            };

            imageWorker.set(img);
            addLogoToPage(img);
            showMessage("success")
        });
    }

    let uploaderCallback = (uploadcare) => {
        nodes.logoWrapper.addEventListener("dragover", function (e) {
            nodes.logoWrapper.classList.add("dragover");
        });

        nodes.logoWrapper.addEventListener("dragleave", function (e) {
            nodes.logoWrapper.classList.remove("dragover");
        });

        uploadcare.dragdrop.uploadDrop(nodes.logoWrapper, function (file) {
            nodes.logoWrapper.classList.remove("dragover");
            progress.start();

            file.always((data) => {
                if(!data.isImage) {
                    uploadError(data);
                }
            })

            file.done(function (params) {
                if (params.isImage) {
                    onUpload(params)                    
                }
            });
        });

        progress.stop();
    }

    let addEventListeners = () => {
        nodes.uploadLogoButton.addEventListener("click", () => {
            let dialog = uploadcare.openDialog(null, {
                validators: [
                    uploader.maxSizeValidator(window.UPLOADCARE_FILE_MAX_MB * 1024 * 1024),
                    uploader.fileTypeValidator('png jpeg jpg gif')
                ]
            });
    
            dialog.done(function imageUploaded(file) {
                createdModal.close();
                progress.start();

                file.always((data, dataFull) => {
                    if((!dataFull && !data.isImage) || (dataFull && !dataFull.isImage)) {
                        uploadError(data);
                    } else if(dataFull && dataFull.sourceInfo.source === "url-tab") {
                        onUpload(dataFull);
                    }
                })

                file.done(function (fileInfo) {
                    onUpload(fileInfo)
                });
    
            }).fail(function () {
                nodes.imgPreview.noLogo.classList.remove("disabled");
                progress.stop();
            });
        });

        // delete
        nodes.logoWrapper.addEventListener("click", (event) => {
            if(event.target.classList.contains("delete-logo")) {
                showConfirmDelete(event.target.dataset.id);
            }
        })

        document.querySelector("body").addEventListener("click", (event) => {
            if(!event.target.classList.contains("delete-logo") 
                && !event.target.classList.contains("confirm-delete") 
                && !event.target.classList.contains("confirm") 
                && !event.target.classList.contains("options")) {
                document.querySelectorAll(".logo.confirm").forEach(element => {
                    element.classList.remove("confirm")
                })
            }

            if(event.target.classList.contains("confirm")) {
                let id = event.target.dataset.id;
                deleteLogo(id);
            }
        })
    }        

    return {
        init: function() {
            uploader.initializeAndWaitUntilReady(
                function(uploadcare){
                    uploaderCallback(uploadcare)
                }
            );

            addEventListeners();
        }
    };
}
);
